import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Marketing footer with legal links and operations disclaimer.
 */
const LandingFooter: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="landing-footer">
      <div className="landing-footer__inner">
        <div className="landing-footer__brand">
          <p className="landing-footer__name">Wine Management System</p>
          <p className="landing-footer__tag">
            Production operations software for winery teams — from vineyard to bottle.
          </p>
        </div>

        <nav className="landing-footer__nav" aria-label="Footer">
          <Link to="/login">Sign in</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <a href="#contact">Contact</a>
        </nav>
      </div>

      <div className="landing-footer__legal">
        <p>
          This product is intended for licensed winery and business operations use.
          It does not provide legal, regulatory, or consumer alcohol sales advice.
          Always follow applicable laws and industry regulations in your jurisdiction.
        </p>
        <p className="landing-footer__copy">
          © {year} Wine Management System. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default LandingFooter;
